import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IRosterTeamOpsHost } from './roster-team-ops.service';
import { RosterMemberService } from './roster-member.service';
import { TeamReportServiceService } from '../team-report/team-report-service.service';
import { CommonDataService } from '../common-data.service';

export interface IRosterNavHost extends IRosterTeamOpsHost {
  memberCurrentPg: number;
  memViewTeam: any;
  teamsPerPage: number;
  teamMemberCurrentPg: number;
  roasterDataCounter: number;
}

@Injectable({ providedIn: 'root' })
export class RosterNavService {

  constructor(
    private rosterMemberService: RosterMemberService,
    private teamReportService: TeamReportServiceService,
    private router: Router,
    private commonDataService: CommonDataService
  ) {}

  // ── navigate to participant view ───────────────────────────────────────────

  participantView(from: string, team: any, mbr: any = '', host: IRosterNavHost): void {
    const updateRoute = () => {
      if (from === 'team') {
        this.router.navigate(['/myteams', `${team.id}`]);
        localStorage.setItem('participantsTeamsAdmin', 'true');
      } else if (from === 'member') {
        localStorage.setItem('participantsTeamsAdmin', 'false');
        this.router.navigate([`/myteams/${team.id}/participant`, `${mbr?.member_id}`]);
      }
    };
    if (team?.memberships_count > 20) {
      this.rosterMemberService.fetchTeamMemberships(team.id, team.memberships_count)
        .pipe(takeUntil(host.destroy$)).subscribe((res) => {
          team['allMembers'] = res.memberships;
          team['memberships'] = res.memberships;
          this.teamReportService.participantTeamData = team;
          localStorage.setItem('participantTeamData', JSON.stringify(team));
          localStorage.setItem('participantData', JSON.stringify(mbr));
          updateRoute();
        });
    } else {
      team['allMembers'] = team.memberships;
      this.teamReportService.participantTeamData = team;
      localStorage.setItem('participantTeamData', JSON.stringify(team));
      localStorage.setItem('participantData', JSON.stringify(mbr));
      updateRoute();
    }
  }

  // ── load more team members or roster members ───────────────────────────────

  loadMore(teamId = '', roaster = 0, allMembers: boolean, host: IRosterNavHost): void {
    if (host.demo_roster_id == host.id) {
      if (allMembers) {
        host.acme_roster.teams.forEach((data: any, index) => {
          if (data['id'] == teamId) {
            host.allTeamIdsTtl[index]['showMember'] = 5;
          }
        });
      } else {
        host.acme_roster.teams.forEach((data: any, index) => {
          if (data['id'] == teamId) {
            host.allTeamIdsTtl[index]['showMember'] = data.memberships_count;
          }
        });
      }
    } else {
      if (roaster > 0) {
        if (allMembers) {
          host.roasterDataCounter = host.teamsData?.members.length;
        } else {
          host.roasterDataCounter = 20;
        }
      } else {
        host.allTeamIdsTtl.forEach((data: any, index) => {
          if (data['teamId'] == teamId) {
            if (data.memberships_count > 20) {
              if (
                data.memberships_count > 20 &&
                host.teams[index].memberships.length < data.memberships_count
              ) {
                host.teamLoaders[teamId] = true;
                this.rosterMemberService.fetchTeamMemberships(teamId, data.memberships_count)
                  .pipe(takeUntil(host.destroy$)).subscribe((res) => {
                    host.teams[index].memberships = res.memberships;
                    host.teamLoaders[teamId] = false;
                  });
              }
            }
            if (allMembers) {
              host.allTeamIdsTtl[index]['showMember'] = host.defaultShowingMembers;
            } else {
              host.allTeamIdsTtl[index]['showMember'] = data.memberships_count;
            }
          }
        });
      }
    }
  }

  // ── update current page and reload data ───────────────────────────────────

  updateCurrentPg(pg: number, host: IRosterNavHost): void {
    if (host.gridHirView === 'memView') {
      host.memberCurrentPg = pg;
      this.commonDataService.getPageData(
        `${environment.profileURL}/api/v1/teams/${host.memViewTeam.id}/memberships.json`,
        pg,
        host.teamsPerPage
      ).pipe(takeUntil(host.destroy$)).subscribe((res: any) => {
        host.memViewTeam.memberships = res?.memberships;
        if (host.gridHirView === 'hierar') { host.hirerachicalData(); }
      });
    } else if (host.gridHirView === 'dirView' || host.gridHirView === 'grid' || host.gridHirView === 'hierar') {
      host.teamMemberCurrentPg = pg;
      this.commonDataService.getPageData(
        `${environment.profileURL}/api/v1/organizations/${host.id}/teams.json`,
        pg,
        host.teamsPerPage
      ).pipe(takeUntil(host.destroy$)).subscribe((res: any) => {
        const filtered = res?.teams?.filter(
          roster => roster.name.toLowerCase() !== 'unassigned' && roster.name.toLowerCase() !== 'admin'
        );
        host.teams = filtered;
        if (host.gridHirView === 'hierar') { host.hirerachicalData(); }
      });
    }
  }
}
